import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';

import ParamsFilterItem from 'components/track-statistics/params-filter-item/ParamsFilterItem';
import ContentLoader from 'controls/content-loader/ContentLoader';

import transmit from 'actions/transmit';
import request from 'actions/request';

class ParamsFilter extends Component {
  handleSubmit(event) {
    event.preventDefault();

    let trackStatistics  = this.props.trackStatistics;
    let trackFilter = this.props.trackFilter;

    if (trackStatistics
      && !this.allEmpty(this.props.trackFilter)
      && Array.isArray(trackStatistics.chosenParams)
      && (trackStatistics.chosenParams.length > 0)
    ) {
      let chosenParams = trackStatistics.chosenParams.map((item) => item.id);
      this.props.request(
        ['trackStatistics', 'getValues'],
        'post',
        'TRACK_STATISTICS_VALUES',
        {
          chosenParams: chosenParams,
          trackFilter: trackFilter
        }
      );
    }
  }

  buildParams(params) {
    return params.map((param) => {
      let label = I18n.t('trackStatistics.paramsFilter.' + param.text);

      return (
        <ParamsFilterItem
          key={ param.id }
          id={ param.id }
          label={ label }
          changeCheckstate={ this.changeCheckstate.bind(this) }
        />
      );
    });
  }

  changeCheckstate (payload) {
    this.props.transmit(
      'CHANGE_TRACK_STATISTICS_PARAM_ITEM_CHECKSTATE',
      payload
    );
  }

  allEmpty (obj) {
    for (var key in obj) {
      if (obj[key] !== null && obj[key] != "")
        return false;
    }
    return true;
  }

  render() {
    let body = I18n.t('trackStatistics.paramsFilter.putTrackFilter');
    let button ='';
    let trackStatistics  = this.props.trackStatistics;

    if (!this.allEmpty(this.props.trackFilter)
      && trackStatistics
      && (trackStatistics.pending === false)
    ) {
      body = I18n.t('trackStatistics.paramsFilter.noMonitoredParamsOnSpecifyedFilter');
    }

    if (trackStatistics && trackStatistics.pending) {
      body = <ContentLoader margin={ 5 } size={ 75 } />;
    }

    if (trackStatistics
      && (trackStatistics.pending === false)
      && Array.isArray(trackStatistics.avaliableParams)
      && (trackStatistics.avaliableParams.length > 0)
    ) {
      body = this.buildParams(trackStatistics.avaliableParams);
      button = <div className="form-group">
        <input type="submit" className="btn btn-default" value={ I18n.t('trackStatistics.paramsFilter.apply') } />
      </div>;
    }

    return (
      <form onSubmit={this.handleSubmit.bind(this)}>
        <p><b><Translate value='trackStatistics.paramsFilter.monitoredParameters' /></b></p>
        { body }
        { button }
      </form>
    );
  }
}

function mapStateToProps(store) {
  return {
    trackStatistics: store.trackStatistics,
    trackFilter: store.trackFilter
  }
}

function mapDispatchToProps(dispatch) {
  return {
    transmit: bindActionCreators(transmit, dispatch),
    request: bindActionCreators(request, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParamsFilter);
